export const subordinateClauses = [
  {
    id: 'dass-satz',
    category: 'nebe',
    level: 'A2',
    title: 'Fjalitë me "dass" (që / se)',
    detailedContent: `
      <section>
        <p>Këto fjali raportojnë, theksojnë një fakt, a transferojnë informacion mbrapa thellë foljeve të perceptimit / shpjegimit. Lidheza "dass" (që / se) drejton krejt Thelbin!</p>

        <h3>Rregulli i Foljes Nënrenditëse (Nebensatz)</h3>
        <p>Ashtu si të GJITHA lidhëzat nënrenditëse: <b>"dass" dërgon thelbin foljor (foljen e zgjedhuar) krejt në fund të fjalisë</b> së dytë (së saj).</p>

        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Foljet Kokat e thelbit "dass":</strong> sagen (themoj), glauben (besoj), wissen (di), hoffen (shpresoj), finden (gjej/mendoj).
        </div>

        <ul>
          <li><i>Ich glaube, <b>dass</b> das Wetter gut <b>wird</b>.</i> (Un beso/ndaj thelb SE moti bëhet i mire - folja wird thellit fund absolut).</li>
          <li><i>Er sagt, <b>dass</b> er keine Zeit <b>hat</b>.</i> (Ai thott Thellë QË / SE ai ska koha -> foljat hat tek fundja).</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [
      { ger: 'Ich hoffe, dass du kommst.', alb: 'Un shpresosh që/se ti vjen. (du kommst -> kommst n fund).' }
    ],
    exercises: [
      { question: 'Përkthe: "E di që ai banon ktu."', options: ['Ich weiß, dass er hier wohnt.', 'Ich weiß, dass er wohnt hier.'], correct: 0, explanation: 'Folja "wohnt" (banon) iken mbrapa (thellit fund) prej lidhzes (dass).' }
    ]
  },
  {
    id: 'weil-satz',
    category: 'nebe',
    level: 'A2',
    title: 'Fjalitë shkakësore "weil / da" (sepse / duke qenë se)',
    detailedContent: `
      <section>
        <p>Japin një Përgjigje eksplicite the lbPytejses "Warum?" (Pse/Per Ç arsye?). "Weil" thelbet e thot "sepse". Kurse "da" luan thell "me qense / duke qen se".</p>
        
        <h3>Arsyeja (Kausalsatz) e thelb-Humb Foljes</h3>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli Praktik:</strong> Folja kryesore nënrendsitse HIDHET DIREKT DRETJ FUNDIT MBARPRA LIdhzsh.
        </div>
        <ul>
          <li><i>Ich lerne Deutsch, <b>weil</b> ich in Berlin leben <b>möchte</b>.</i> (un meso germ Thelb, sepse nBerlin tëJetoi dëshiroj=moche fund thelb).</li>
          <li><i><b>Da</b> es regnet, <b>bleiben</b> wir zu Hause.</i> Kujdes!! Kur fjalia nis thells ME LIDHEZ! Fjalia tytet nis Thells DIREK ME FOLJË kryerose t (thelb inversin : bleiben wir !).</li>
        </ul>
      </section>
    `,
    exercises: []
  },
  {
    id: 'wenn-satz',
    category: 'nebe',
    level: 'B1',
    title: 'Fjalitë kushtore/kohore "wenn / als" (Nëse / Kur)',
    detailedContent: `
      <section>
        <p>Gjermanishtja ndan dritshëm Dy kohët e thembes (kur/if). "Wenn" mbulon Të Tashmen,tardhmen DHE t shquarën përsëritese. Ndwrsa "Als" ka 1 te drejte = Vettem per thell ngjarjshn TË SHKUARËS një herore.</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Wenn =</strong> Kushte (If/Nëse) APO "Kurdo qe/Sa herm Thelb" t rregullat. <br>
          <strong>Als =</strong> Vetëm për dritar Kohët E SHKUARA!
        </div>

        <ul>
          <li>Kushte t tashme: <i><b>Wenn</b> es regnet, bleiben wir hier.</i> (Thelb kshu foljash: Nëse/Kur t bie shi - Thelli Rrime thelb N ktu).</li>
          <li>Koha e shkuara absolute e that: <i><b>Als</b> ich ein Kind <b>war</b>, <b>liebte</b> ich Schokolade.</i> (THELB Kur ishat un fmijë, doha thelb cokolla. *NUK asht Thelb Wenn!*).</li>
        </ul>
      </section>
    `,
    exercises: []
  },
  {
    id: 'obwohl-satz',
    category: 'nebe',
    level: 'B1',
    title: 'Fjalitë thelbKundërshtuese "obwohl" (Edhe Pse / Megjithëse)',
    detailedContent: `
      <section>
        <p>Qyquhen fali "Konzessiv". Këto Thelb japin Kompromisen, nji rezultat TË PAPRITUR Thelb në dritn e shkakut aktual Thelb.</p>
        
        <ul>
          <li><i>Ich gehe thelb spazieren, <b>obwohl</b> es stark <b>regnet</b>.</i> (Un eci/shetis, THELBE ME GJITH SE posht thelb BIEN shi! - pritshet t thelesh brenda po ti ishe eci).</li>
          <li><i><b>Obwohl</b> er krank <b>ist</b>, <b>arbeitet</b> er.</i> (Edhe thell pse ai smur asht... Ai Thelb puNOn . folja + foJA thelb mbrapa. Ist arbeiten.) </li>
        </ul>
      </section>
    `,
    exercises: []
  },
  {
    id: 'damit-satz',
    category: 'nebe',
    level: 'B2',
    title: 'Fjalitë Qëllimore "damit / um ... zu" (Me Qëllim që)',
    detailedContent: `
      <section>
        <p>E tregoj thell thellshm Qëllimin "WARUM / WOZU" thelbes. (Per C Qellm? / Q p qellim q). </p>
        
        <h3>Dallimet Damit VS Um...zu</h3>
        <p>1. <b>Damit (në mnyr e thelbes që)</b> = Përdoret kur Subjekiti Thelb 1 (Une jap lesktra a kshilla) asht I NDRYSHEN me Subjekt e dyte (Q TIl ti mësosh Thelb!).</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <i>Ich helfe dir, <b>damit du</b> the test <b>bestehst</b>.</i> (un Thelb t nihe ty.. thelbs Q TE kalosh TY Thelb provim - Subjket 1:Un. Subjketr2: TI.)
        </div>

        <p>2. <b>Um ... zu (Për Thelb... të ..+ Infinitiv)</b> = S'kanë Subjenket të the dyle mbrend thelb, Fjalinë E Kryern 1-it Subjeknt kryser. The Infinitive hidhën atye thelb e mbarr m (zu thelb).</p>
        <div class="p-4 border border-gray-200">
          <i>Ich thelb lerne die Thelbs Deutsch, <b>um</b> in thelb DE <b>zu studieren</b>.</i> (Un msoj gjermahin Thellh - PER THELB TE sdtuditjuar -Thells Subjekit ashte T dyans Veten UN/ICH).
        </div>
      </section>
    `,
    exercises: []
  }
];
